import { Suspense, createContext, useContext, useEffect, useMemo, useState } from "react";
import { IoClose } from "react-icons/io5";
import styled from "styled-components";

import { HeroInput, HeroInputField2, HeroInputIcon, HeroInputReset } from "../ui-kit";


function Mod(props) {
    const { name, onLoading, onResults, options, token, useSearch } = props;

    const { loading, results } = useSearch(token, options);

    useEffect(
        () => {},
        [],
    );

    useEffect(
        () => {
            onResults(name, results);
        },
        [results],
    );

    useEffect(
        () => {
            onLoading(name, loading);
        },
        [loading],
    );

    return undefined;
}

export default function Finder(props) {
    const { moduleOptions, modules, onSelect, placeholder } = props;

    const [token, setToken] = useState<string>("");
    const [results, setResults] = useState({});
    const [loading, setLoading] = useState({});

    useEffect(
        () => {
            setResults({});
            setLoading({});
        },
        [token],
    );

    function onResults(name, entities) {
        setResults(
            (r) => ({ ...r, [name]: entities })
        );
    }

    function onLoading(name, loading) {
        setLoading(
            (l) => ({ ...l, [name]: loading })
        );
    }

    if (!modules.length) return undefined;

    return (
        <div>
            {
                modules.map(
                    (module) => (
                        <Mod
                            { ...module }
                            key={ module.name }
                            onLoading={ onLoading }
                            onResults={ onResults }
                            options={ moduleOptions }
                            token={ token }
                        />
                    )
                )
            }
            <HeroInputField2>
                <HeroInputIcon />
                <HeroInput
                    onChange={ setToken }
                    placeholder={ placeholder ?? "Search" }
                    value={ token }
                />
                <HeroInputReset
                    onClick={ () => setToken("") }
                >
                    <IoClose />
                </HeroInputReset>
            </HeroInputField2>
            {
                Object.values(loading).includes(true) && <div>loading</div>
            }
            <ul style={ { listStyle: "none" } }>
                {
                    modules.map(
                        (module) => (results[module.name] ?? []).map(
                            (entity) => {
                                const { Component, getID } = module;
                                return (
                                    <li key={ getID(entity) }>
                                        <Component
                                            { ...entity }
                                            onClick={ () => onSelect(module.name, getID(entity), entity) }
                                        />
                                    </li>
                                );
                            }
                        )
                    )
                }
            </ul>
        </div>
    );
}

const FinderContext = createContext(undefined);

export function Finder2(props) {
    const { children, placeholder } = props;

    const [token, setToken] = useState("");

    const contextValue = useMemo(
        () => (
            {
                token,
            }
        ),
        [token],
    );

    return (
        <FinderContext.Provider value={ contextValue }>
            <Styled>
                <HeroInputField2>
                    <HeroInputIcon />
                    <HeroInput
                        onChange={ setToken }
                        placeholder={ placeholder ?? "Search" }
                        value={ token }
                    />
                    <HeroInputReset
                        onClick={ () => setToken("") }
                    >
                        <IoClose />
                    </HeroInputReset>
                </HeroInputField2>
                <Suspense fallback={ <div>loading</div> }>
                    <ul style={ { listStyle: "none" } }>
                        { children }
                    </ul>
                </Suspense>
            </Styled>
        </FinderContext.Provider>
    );
}

const Styled = styled.div`
    ${ HeroInputField2 } {
        margin: 8px;
    }
`;

export function useFinder() {
    return useContext(FinderContext);
}
